<template>
<!-- HISTORY:
   V250618.1: Obtained and displayed files schemas when lake directory nodes are clicked.
   V250617.1: 1st version/release.
-->
<v-container fluid class="px-0 py-3">
   <v-card class="px-0">
      <v-card-title>
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-1">folder_open</v-icon>
            <span>File Structure</span>
         </h1>
         <div class="flex-grow-1"></div>
      </v-card-title>
      <v-card-text>
         <v-row>
            <v-col cols="6"><!-- LEFT/S3 PANEL -->
            <v-expansion-panels focusable inset
               v-model="s3Panel"
            >
               <v-expansion-panel readonly>
                  <!-- <v-expansion-panel-header hide-actions>Object Storage: {{s3FilesCount}}</v-expansion-panel-header> -->
                  <v-expansion-panel-header hide-actions>
                     <div class="d-flex justify-space-between align-center w-100">
                        <span>Object Storage</span>
                        <span class="ml-auto">{{ s3FilesCount }}</span>
                     </div>
                  </v-expansion-panel-header>                  
                  <v-expansion-panel-content>
                     <v-card flat :loading="loadingS3Tree">
                        <v-card-text>
                           <bt-file-tree v-if="s3Tree"
                              :nodes="s3Tree"
                              :is-clickable="false"
                              @click="onNodeClick"
                           />
                           <v-skeleton-loader v-else
                              type="list-item"
                           />
                        </v-card-text>
                     </v-card>
                  </v-expansion-panel-content>
               </v-expansion-panel>
            </v-expansion-panels>
            </v-col>

            <v-col cols="6"><!-- RIGHT/LAKE PANEL -->
            <v-expansion-panels focusable inset
               v-model="lakePanel"
            >
               <v-expansion-panel readonly>
                  <!-- <v-expansion-panel-header hide-actions>Containers Shared Storage: {{lakeFilesCount}}</v-expansion-panel-header> -->
                  <v-expansion-panel-header hide-actions>
                     <div class="d-flex justify-space-between align-center w-100">
                        <span>Containers Shared Storage</span>
                        <span class="ml-auto">{{ lakeFilesCount }}</span>
                     </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                  <v-card flat
                     class="px-0"
                     :loading="loadingLakeTree"
                  >
                     <v-card-text>
                        <bt-file-tree v-if="lakeTree"
                           :nodes="lakeTree"
                           :is-clickable="true"
                           @click="onNodeClick"
                        />
                        <v-skeleton-loader v-else
                           type="list-item"
                        />
                     </v-card-text>
                  </v-card>
                  </v-expansion-panel-content>
               </v-expansion-panel>
            </v-expansion-panels>
            </v-col>
         </v-row>
      </v-card-text>
   </v-card>

   <v-dialog no-click-animation persistent
      max-width="640px"
      v-model="dialogSchemas"
   >
      <v-card flat>
         <v-card-title class="title grey--text darken-4 font-weight-bold pb-2">Schemas for {{clickedNode}}:</v-card-title>

         <v-card-text class="pt-2 pb-0">
            <v-data-table dense fixed-header
               class="elevation-1"
               item-key="column_name"
               :footer-props="{
                  itemsPerPageOptions: [5, 10, 20, -1],
                  showFirstLastPage: true
               }"
               :headers="headers"
               :hide-default-footer="schemas.length <= 5"
               :items="schemas"
               :items-per-page="10"
               :loading="loadingSchemas"
               :loading-text="$t('loading-text')"
               :no-data-text="$t('no-data-text', { value: 'schemas' })"
               :no-results-text="$t('no-results-text', { value: 'schemas' })"
               :search="search"
            ></v-data-table>
         </v-card-text>

         <v-card-actions class="pr-4">
            <div class="flex-grow-1"></div>
            <v-btn text
               color="blue darken-1"
               @click="dialogSchemas = false"
            >Close</v-btn>
         </v-card-actions>
      </v-card>
   </v-dialog>
</v-container>
</template>

<script>
import BtFileTree from './BtFileTree.vue';
import { APIService } from '../services/ls-api-service.js';

const NAME = "LsFileStructure";

export default {
   name: NAME,

   components: {
      BtFileTree
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },
      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         jwt: {},
         apiService: null,
         loadingS3Tree: false,
         loadingLakeTree: false,
         s3Panel: 0,
         lakePanel: 0,
         s3Tree: null,
         lakeTree: null,
         dialogSchemas: false,
         loadingSchemas: false,
         search: '',
         headers: [
            { text: 'Column Name', value: 'column_name', align: 'left', sortable: true },
            { text: 'Column Type', value: 'column_type', align: 'left', sortable: true }
         ],
         schemas: [],
         clickedNode: {}
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      s3FilesCount() {
         // alert(this.countFiles(this.s3Tree));
         return this.countFiles(this.s3Tree).csv + ' csv';
      },

      lakeFilesCount() {
         const { csv, parquet } = this.countFiles(this.lakeTree);
         return `${csv} csv & ${parquet} parquet`;
      }
   },

   watch: {
      token() {
         this.init();
      }
   },

   methods: {
      log(msg) {
         if (this.debug)
            console.log(`-----${NAME} V250618.1 says => ${msg}`);
      },

      logout() {
         this.$router.push('/');
      },

      async init() {
         if (this.token) {
            this.jwt = JSON.parse(Buffer.from(this.token.split('.')[1], 'base64'));
            this.apiService = new APIService(this.jwt, this.token, this.debug, this.isActualEndpoint);
            await this.getS3Directories();
            if (this.s3Tree.length)
               await this.getLakeDirectories();
         }
      },

      async getS3Directories() {
         this.loadingS3Tree = true;
         // this.btnRefreshS3TreeDisabled = true;
         // this.s3TreeDisabledDuration = 30;
         let result = await this.apiService.getS3Directories();
         this.loadingS3Tree = false;

         if (result.logout)
            this.logout();
         else if (result.message)
            this.s3Tree = [];
         else {
            this.s3Tree = result.data;
            // if (this.s3Tree.length) {
            //    setTimeout(() => {
            //       this.btnRefreshExportsDisabled = false;
            //    }, 1000 * 30);

            //    const setIntervalExports = setInterval(() => {
            //       if (this.exportsDisabledDuration > 0)
            //          this.exportsDisabledDuration--;
            //       else
            //          clearInterval(setIntervalExports);
            //    }, 1000);
            // }
         }
      },

      async getLakeDirectories() {
         this.loadingLakeTree = true;
         // this.btnRefreshLakeTreeDisabled = true;
         // this.lakeTreeDisabledDuration = 30;
         let result = await this.apiService.getLakeDirectories();
         this.loadingLakeTree = false;

         if (result.logout)
            this.logout();
         else if (result.message)
            this.lakeTree = [];
         else {
            this.lakeTree = result.data;
            // if (this.lakeTree.length) {
            //    setTimeout(() => {
            //       this.btnRefreshLakeTreeDisabled = false;
            //    }, 1000 * 30);

            //    const setIntervalExports = setInterval(() => {
            //       if (this.exportsDisabledDuration > 0)
            //          this.exportsDisabledDuration--;
            //       else
            //          clearInterval(setIntervalExports);
            //    }, 1000);
            // }
         }
      },

      // countFiles(nodes) {
      //    let count = 0;
      //    nodes?.forEach(node => {
      //       if (node.type === 'file')
      //          count++;
      //       else if (node.children)
      //          count += this.countFiles(node.children);
      //    });
      //    return count;
      // },

      countFiles(nodes) {
         let csvCount = 0;
         let parquetCount = 0;

         nodes?.forEach(node => {
            if (node.type === 'file') {
               if (node.name.endsWith('.csv')) csvCount++;
               else if (node.name.endsWith('.parquet')) parquetCount++;
            } else if (node.type === 'directory' && node.children) {
               const childCounts = this.countFiles(node.children);
               csvCount += childCounts.csv;
               parquetCount += childCounts.parquet;
            }
         });

         return { csv: csvCount, parquet: parquetCount };
         // return { csvCount, parquetCount };
      },

      async onNodeClick({year, month}) {
         // alert(`in onNodeClick(): year=${year}, month=${month}`);
         this.dialogSchemas = true;
         this.loadingSchemas = true;
         this.schemas = [];
         this.clickedNode = year + '/' + (month || '*');
         let result = await this.apiService.getSchemas(this.clickedNode);
         this.loadingSchemas = false;
         if (result.logout)
            this.logout();
         else if (!result.message)
            this.schemas = result.data;
      }
   },

   created() { },

   mounted() {
      this.init();
   }
}
</script>